/* ============
 * Actions for the followUps module
 * ============
 *
 * The actions that are available on the
 * followUps module.
 */
import Vue from 'vue';
import FollowUpProxy from '@/proxies/FollowUpsProxy';
import types from './mutation-types';
import message from '@/constants/_message';

export const create = ({ commit }, data) => {
  commit(types.CREATE_FOLLOW_UP);
  new FollowUpProxy().create(data).then((response) => {
    commit(types.CREATE_FOLLOW_UP_SUCCESS, response);
    Vue.router.push({
      name: 'followUp.index'
    });
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.FOLLOW_UP_CREATED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.CREATE_FOLLOW_UP_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.FOLLOW_UP_NOT_CREATED,
      type: 'error'
    });
  });
};

export const update = ({ commit, dispatch }, {filter, data}) => {
  commit(types.UPDATE_FOLLOW_UP);
  new FollowUpProxy().update(data).then(() => {
    dispatch('fetchFollowUps', filter);
    commit(types.UPDATE_FOLLOW_UP_SUCCESS);
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.FOLLOW_UP_UPDATED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.UPDATE_FOLLOW_UP_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.FOLLOW_UP_NOT_UPDATED,
      type: 'error'
    });
  });
};

export const fetchFollowUps = ({commit}, data) => {
  commit(types.FETCH_FOLLOW_UP_LIST);
  new FollowUpProxy().fetchFollowUps(data).then((response) => {
    commit(types.FETCH_FOLLOW_UP_LIST_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_FOLLOW_UP_LIST_FAIL, error);
  });

};

export const remove = ({ commit, dispatch }, {data,id}) => {
  commit(types.DELETE_FOLLOW_UP);
  new FollowUpProxy().remove(id).then(() => {
    dispatch('fetchFollowUps', data);
    commit(types.DELETE_FOLLOW_UP_SUCCESS);
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.FOLLOW_UP_DELETED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.DELETE_FOLLOW_UP_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.FOLLOW_UP_NOT_DELETED,
      type: 'error'
    });
  });
};

export const getFollowUpSymptoms = ({ commit }, id) => {
  commit(types.GET_FOLLOW_UP_SYMPTOMS);
  new FollowUpProxy().getFollowUpSymptoms(id).then((response) => {
    commit(types.GET_FOLLOW_UP_SYMPTOMS_SUCCESS, response);
  }).catch((error) => {
    commit(types.GET_FOLLOW_UP_SYMPTOMS_FAIL, error);
  });
};

export const resolve = ({ commit }, { formData, isCompleted, successCb }) => {
  commit(types.RESOLVE_FOLLOW_UP_ALERT);
  new FollowUpProxy().resolve(formData)
    .then((response) => {
      commit(types.RESOLVE_FOLLOW_UP_ALERT_SUCCESS, response);
      if (isCompleted) {
        successCb();
        Vue.notify({
          group: 'notification',
          title: 'Success',
          text: message.FOLLOW_UP_RESOLVED,
          type: 'success'
        });
      }
    }).catch((error) => {
      commit(types.RESOLVE_FOLLOW_UP_ALERT_FAIL, error);
      if (isCompleted) {
        Vue.notify({
          group: 'notification',
          title: 'Error',
          text: message.FOLLOW_UP_NOT_RESOLVED,
          type: 'error'
        });
      }
    });
};

export const getResolvedNotes = ({ commit }, data) => {
  commit(types.FETCH_RESOLVED_NOTES);
  new FollowUpProxy().getResolvedNotes(data)
    .then((response) => {
      commit(types.FETCH_RESOLVED_NOTES_SUCCESS, response);
    }).catch((error) => {
      commit(types.FETCH_RESOLVED_NOTES_FAIL, error);
    });
};

export default {
  create,
  update,
  fetchFollowUps,
  remove,
  getFollowUpSymptoms,
  resolve,
  getResolvedNotes
};
